import checkout from "./form";

const {
  formField: { taxId, conpanyName, releaseDate, representative, totalTax },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
  [totalTax.name]: "",
};

export default initialValues;
